// src/CanvasTerrain.jsx
import { useEffect, useRef } from "react";
import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";

export default function CanvasTerrain() {
  const canvasRef = useRef();

  useEffect(() => {
    const scene = new THREE.Scene();
    scene.background = new THREE.Color(0xcccccc);

    const camera = new THREE.PerspectiveCamera(45, window.innerWidth / window.innerHeight, 0.1, 100);
    camera.position.set(0, 10, 15);

    const renderer = new THREE.WebGLRenderer({ canvas: canvasRef.current, antialias: true });
    renderer.setSize(window.innerWidth, window.innerHeight);
    renderer.setPixelRatio(window.devicePixelRatio);

    const controls = new OrbitControls(camera, renderer.domElement);
    controls.enableDamping = true;

    const light = new THREE.DirectionalLight(0xffffff, 1.2);
    light.position.set(10, 20, 10);
    scene.add(light);
    scene.add(new THREE.AmbientLight(0x404040));

    const loader = new THREE.TextureLoader();
    Promise.all([
      loader.loadAsync("/images/diffuse.png"),
      loader.loadAsync("/images/height.png")
    ])
    .then(([diffuse, heightMap]) => {
      const geometry = new THREE.PlaneGeometry(10, 10, 256, 256);
      geometry.rotateX(-Math.PI / 2);

      const canvas2D = document.createElement("canvas");
      canvas2D.width = heightMap.image.width;
      canvas2D.height = heightMap.image.height;
      const ctx = canvas2D.getContext("2d");
      ctx.drawImage(heightMap.image, 0, 0);
      const imgData = ctx.getImageData(0, 0, canvas2D.width, canvas2D.height).data;

      const positions = geometry.attributes.position;
      for (let i = 0; i < positions.count; i++) {
        const x = i % canvas2D.width;
        const y = Math.floor(i / canvas2D.width);
        const idx = (y * canvas2D.width + x) * 4;
        const height = imgData[idx] / 255;
        positions.setY(i, height * 3);
      }
      geometry.computeVertexNormals();

      const material = new THREE.MeshStandardMaterial({
        map: diffuse,
        displacementMap: heightMap,
        displacementScale: 0,
      });

      const terrain = new THREE.Mesh(geometry, material);
      scene.add(terrain);

      const animate = () => {
        controls.update();
        renderer.render(scene, camera);
        requestAnimationFrame(animate);
      };
      animate();
    });

    const onResize = () => {
      camera.aspect = window.innerWidth / window.innerHeight;
      camera.updateProjectionMatrix();
      renderer.setSize(window.innerWidth, window.innerHeight);
    };
    window.addEventListener("resize", onResize);

    return () => {
      window.removeEventListener("resize", onResize);
    };
  }, []);

  return <canvas ref={canvasRef} style={{ width: "100%", height: "100vh", display: "block" }} />;
}
